@if(tableFolderDeleteModal) {
    <app-modal *ngIf="tableFolderDeleteModal" [modalInput]="tableFolderDeleteModal" (modalCloseOutput)="handleModalClose($event)" class="table-folder-delete-modal">
        <form class="modal-content flexGrow1" [formGroup]="form">

            <div class="body-content">
                <div class="confirmation-body-text"
                    [innerHTML]="'table.delete-folder-confirmation.body' | translate:tableFolderDeleteModal.params">
                </div>

                <div class="counts-block">
                    <p class="count-line"><strong>{{ tableFolderDeleteModal.params.entityCount }} {{ entity | lowercase }}</strong></p>
                    <p class="count-line"><strong>{{ tableFolderDeleteModal.params.subFolderCount }} {{
                        tableFolderDeleteModal.params.subFolderCount === 1 ?
                            ('table.delete-folder-confirmation.sub-folder' | translate) :
                            ('table.delete-folder-confirmation.sub-folders' | translate)
                    }}</strong></p>
                </div>

                <p class="confirmation-instructions-text">
                    {{ 'table.delete-folder-confirmation.instructions' | translate:tableFolderDeleteModal.params }}
                </p>

                <div class="folder-input">
                    <app-input
                        errorClass="block"
                        width="180px"
                        formControlName="folderName"
                    />
                </div>
            </div>

            <div class="actions">
                <app-form-buttons
                    [submitDisabled]="form.invalid"
                    submitTextKey="generics.delete"
                    (submitOutput)="submit()"
                    (cancelOutput)="cancel()"
                ></app-form-buttons>
            </div>
        </form>
    </app-modal>
}
